/**
 * The language the patient reads, for the AI conversations: "en" | "es" | "sw".
 *
 * Read at call time, not at render, so a patient who switches language in Settings gets the
 * next reply in the new one. Sent as `language` with each patient-facing callLLMAPI request,
 * where functions/src/nlp/responseLanguage turns it into the prompt instruction. Anything we
 * have no instruction for is English, which sends no instruction at all.
 */

import i18n from "i18n";

const AI_LANGUAGES = ["en", "es", "sw"];

export function patientLanguage() {
  const code = String(i18n.resolvedLanguage || i18n.language || "en")
    .toLowerCase()
    .split(/[-_]/)[0];
  return AI_LANGUAGES.includes(code) ? code : "en";
}

/** BCP-47 tag the CareStart voice engines speak, transcribe and translate in. */
const VOICE_LANGUAGE = { en: "en-US", es: "es-ES", sw: "sw-KE" };

export function patientVoiceLanguage() {
  return VOICE_LANGUAGE[patientLanguage()];
}
